import { MainMenu, Widget } from 'rangeConfig/@types';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import hideDoors from 'rangeConfig/shared/behaviors/hideDoors';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import framesProductListConfig from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';

import {
  depthFilter,
  heightFilterWithSizeLabel,
  widthFilter
} from 'rangeConfig/shared/filters/configFilters';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';
import { smastadFrameTypeFilter } from 'rangeConfig/smastad/filters/configFilters';

const widgets = {
  desktop: [
    {
      id: 'product-list-filters',
      component: ProductSortFilterWidget
    } as Widget,
    { id: 'frames-product-list', component: withProducts(ProductList, framesProductListConfig) }
  ],
  mobile: [
    {
      id: 'frame-product-list',
      component: withProducts(ProductSwiper, framesProductListConfig),
      title: 'storageone.productListFramesTitle'
    }
  ]
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListFramesTitle',
  behaviors: {
    productGroupEntered: [hideDoors],
    productGroupExited: [showDoors]
  },
  filters: [smastadFrameTypeFilter, heightFilterWithSizeLabel, widthFilter, depthFilter],
  widgets: widgets[platform]
};

export default mainMenu;
